import { render, staticRenderFns } from "./EmployeeNewConfiguration.vue?vue&type=template&id=215873aa&"
import script from "./EmployeeNewConfiguration.vue?vue&type=script&lang=js&"
export * from "./EmployeeNewConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports